// extracted by mini-css-extract-plugin
export default {"mCard":"PB-z","image":"QB-z","imageNoBackground":"RB-z","imageHasCategory":"SB-z","fullWidth":"TB-z"};